import { render, staticRenderFns } from "./employee-rate.vue?vue&type=template&id=504fb54c"
import script from "./employee-rate.vue?vue&type=script&lang=js"
export * from "./employee-rate.vue?vue&type=script&lang=js"
import style0 from "./employee-rate.vue?vue&type=style&index=0&id=504fb54c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports